import { render, staticRenderFns } from "./RaidersGoods.vue?vue&type=template&id=209b72b1&"
import script from "./RaidersGoods.vue?vue&type=script&lang=js&"
export * from "./RaidersGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports